module.exports = __webpack_public_path__ + "static/media/bCassidy.7f77156f.jpeg";